import { jsonParse } from '@utils/json';

export const hasLocalizationDebug = (): boolean => {
  try {
    const raw = localStorage.getItem('USER_PREFERENCES') as string;
    const json = jsonParse<{ localizationDebug: boolean }>(raw);
    return json?.localizationDebug || false;
  } catch (err) {
    return false;
  }
};

export const DEBUG_STRING = '@@@@@@';
